<template>
  <div style="width: 100%;height: 100%">
    <!--    <div v-if="design" class="activeMask"/>-->
    <div :id="uuid" style="width: 100%;height:100%;" />
  </div>
</template>

<script setup>
import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { fileUrl } from "/env";
import { onBeforeUnmount, onMounted, watch } from "vue";
// import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  design: Boolean
})

let uuid = require('uuid').v1()
let scene = null
let renderer = null
let camera = null
let ambientLight = null
let pointLight = null
let loader = null
let models = []
let controls = null
let clock = null
let mixer = null
let animate = null
let plane = null
let lastUrl = ''

function initScene() {
  clock = new THREE.Clock();
  scene = new THREE.Scene();//创建场景对象Scene
  camera = new THREE.PerspectiveCamera(40, 1, 0.1, 20000);//相机
}
function createMesh() {
  const planeGeometry = new THREE.PlaneGeometry(1, 1, 1, 1) // 创建一个平面对象PlaneGeometry
  const planeMaterial = new THREE.MeshLambertMaterial({ color: 0xffffff }) // 材质对象Material
  plane = new THREE.Mesh(planeGeometry, planeMaterial)
  plane.receiveShadow = true

  // 设置平面位置
  plane.rotation.x = -0.5 * Math.PI
  plane.position.set(0, 0, 0)
  scene.add(plane)
}
function createRender() {//渲染器
  let container = document.getElementById(uuid);
  if(!container) {
    return true
  }
  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setSize(props.width, props.height);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.outputEncoding = THREE.sRGBEncoding;
  //告诉渲染器需要阴影效果
  renderer.shadowMap.enabled = true;
  container.appendChild(renderer.domElement);
}
function createLight() {
  ambientLight = new THREE.AmbientLight();
  scene.add(ambientLight);

  pointLight = new THREE.PointLight();
  pointLight.castShadow = true;//告诉平行光需要开启阴影投射
  scene.add(pointLight);
}
function createControls() {//控件对象
  controls = new OrbitControls(camera, renderer.domElement);
  controls.target.set(0, 0, 0);
  controls.enablePan = true;
  controls.rotateSpeed = 1;
  controls.enableDamping = true;
  controls.maxDistance = 10000;
  controls.minDistance = 0.00001;
}
function loadModel() {//模型加载
  removeMesh(models);//切换模型时删除之前加载的模型
  loader = new GLTFLoader();
  let dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath('/three/gltf/');
  loader.setDRACOLoader(dracoLoader);
  let url = props.option.attribute.modeUrl ? fileUrl + props.option.attribute.modeUrl : '/three/model/floor/TwoSidedPlane.gltf'
  loader.load(url, (gltf) => {
    gltf.scene.traverse((node) => {
      if (node.isMesh || node.isLight) {
        node.castShadow = true;
        // node.receiveShadow = true;//阴影投射到模型自身
      }
    });
    gltf.scene.position.set(0, 0, 0);
    // gltf.scene.scale.set( 1, 1, 1 );
    models[0] = gltf;
    setScaleToFitSize(gltf.scene);
    scene.add(gltf.scene);
    if (gltf.animations.length > 0) {//模型动画
      mixer = new THREE.AnimationMixer(gltf.scene);
      loadModelAnima();
    }
    cancelAnimationFrame(animate);//销毁动画
    animateRun();
  });
}
function reloadOption(attribute) {//配置项加载
  renderer.setClearColor(new THREE.Color(attribute.bgColor), attribute.bgAlpha);
  ambientLight.color = new THREE.Color(attribute.ambientLightColor);
  pointLight.color = new THREE.Color(attribute.pointLightColor);
  pointLight.position.set(attribute.pointLightX, attribute.pointLightY, attribute.pointLightZ);
}
function animateRun() {//动画
  animate = requestAnimationFrame(animateRun);
  models[0].scene.rotation.y += 0.001;
  const delta = clock.getDelta();
  if (mixer) {
    mixer.update(delta);
  }
  controls.update();
  renderer.render(scene, camera);
}
function removeMesh(meshes) {
  meshes.forEach(item => {
    scene.remove(item.scene)
  })
}
function loadModelAnima() {
  mixer.stopAllAction()
  mixer.clipAction(models[0].animations[props.option.attribute.animateIndex]).play();
}
function setScaleToFitSize(obj) {
  const boxHelper = new THREE.BoxHelper(obj);
  boxHelper.geometry.computeBoundingBox();
  const box = boxHelper.geometry.boundingBox;

  let modelLen = box.max.x - box.min.x; // 模型长度
  let modelHeight = box.max.y - box.min.y; // 模型高度
  let modelWidth = box.max.z - box.min.z; // 模型宽度

  let x1 = box.min.x + modelLen / 2; // 模型中心点坐标X
  let y1 = box.min.y + modelHeight / 2; // 模型中心点坐标Y
  let z1 = box.min.z + modelWidth / 2; // 模型中心点坐标Z
  let diagonal = Math.sqrt(Math.pow(Math.sqrt(Math.pow(modelLen, 2) + Math.pow(modelWidth, 2)), 2) + Math.pow(modelHeight, 2)); // 获取模型整体对角线长度,这里获取模型模型对角线的目的是为了保证模型可以完全的展示在视线范围内
  // 假设我们需要的进入视角为45度
  camera.position.set(box.max.x + diagonal / 2, (diagonal * 2) / Math.tan(Math.PI / 180 * 45) + Math.abs(box.max.y), box.max.z + diagonal / 2); // 设置相机位置，向上偏移，确定可以包裹整个模型
  camera.lookAt({ x: x1, y: y1, z: z1 });
  if (box.min.y <= 0) {//重置Y轴在0之上
    models[0].scene.position.set(0, Math.abs(box.min.y) + 1, 0);
  }
  // plane.scale.set(modelLen*10,modelWidth*10,1)
}



onMounted(() => {
  const isNullElement = createRender();// 创建渲染器
  if(isNullElement) {
    return
  }
  initScene(props.option.attribute);//创建场景和相机
  // createMesh();// 创建网格模型
  createLight();// 创建光源
  createControls();// 创建控件对象
  loadModel();//加载模型
  reloadOption(props.option.attribute);//更改配置项
})

watch(props.option.attribute, (obj) => {
  reloadOption(obj);
  if (lastUrl !== props.option.attribute.modeUrl) {
    loadModel(obj);
  }
  lastUrl = props.option.attribute.modeUrl
})
watch(() => [props.width, props.height], () => {
  renderer.setSize(props.width, props.height)
})


onBeforeUnmount(() => {
  cancelAnimationFrame(animate);
  console.log(scene, 'scenescene');
  if (scene) scene.clear();
  scene = null;
  if(renderer) renderer.clear();
  camera = null;
  if(controls) controls.dispose();
})
</script>

<style scoped>
.activeMask {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1801;
}
</style>
